import { createSlice } from "@reduxjs/toolkit";

interface UserState {
  user: null | any;
  showAuthPopup: boolean;
}

const initialState: UserState = {
  user: null,
  showAuthPopup: false,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    storeUserData: (state, action) => {
      state.user = action.payload;
    },
    showPopup: (state, action) => {
      state.showAuthPopup = action.payload;
    },
  },
});

export const { storeUserData, showPopup } = userSlice.actions;

export default userSlice.reducer;
